import { getRequest } from "../utils/api";

export const EmailLogService = {
  getAllAddress: async ({ customer_address, page, limit }) => {
    const offset = (page - 1) * limit;
    return await getRequest(
      `/email-event?recipient_address=${customer_address}`,
      {
        params: { limit, offset },
      }
    );
  },
  getAllLogs: async () => {
    return await getRequest(`/email-event?`, {});
  },
  getAllLogsPagination: async ({ limit, page }) => {
    const offset = (page - 1) * limit;
    return await getRequest(`/email-event?`, {
      params: { limit, offset },
    });
  },
  getLogBySesConfig: async ({ ses_config_set, page, limit, selected }) => {
    const offset = (page - 1) * limit;
    return await getRequest(`/email-event/?${selected}=${ses_config_set}`, {
      params: { limit, offset, page },
    });
  },
  getEvent: async (id) => {
    return await getRequest(`/email-event/${id}`, {});
  },
  getBySesAndEvenType: async ({ ses_config_set, page, limit, event_type }) => {
    const offset = (page - 1) * limit;
    return await getRequest(
      `/email-event/getwitheventtype/sesconfigset?ses_config_set=${ses_config_set}`,
      { params: { event_type, limit, offset, page } }
    );
  },
  getByEmailAndEventType: async ({
    recipient_address,
    page,
    limit,
    event_type,
  }) => {
    const offset = (page - 1) * limit;
    return await getRequest(
      `/email-event/getwitheventtype/emailid?recipient_address=${recipient_address}`,
      { params: { event_type, limit, offset, page } }
    );
  },
  getByEventType: async ({ event_type, page, limit }) => {
    const offset = (page - 1) * limit;
    return await getRequest(`/email-event?`, {
      params: {
        event_type,
        limit,
        offset,
      },
    });
  },
};
